module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "lo"
    }
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "gb"
  }), _vm._v(" "), _c('p', {
    staticClass: "gb"
  }), _vm._v(" "), _c('p', {
    staticClass: "gb"
  }), _vm._v(" "), _c('p', {
    staticClass: "gb"
  }, [_vm._v("Other Books by Jef Mallett")]), _vm._v(" "), _c('p', {
    staticClass: "nor"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Frazz: Live at Bryson Elementary")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b32fd174","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LO-03.vue
// module id = 63
// module chunks = 0